import { trackApparelCollectionsCollectionDetailsMoreCollectionsCollectionClick } from "@faire/web-api/events/apparelCollections/click/collectionDetailsMoreCollectionsCollection";
import { ICollectionTile } from "@faire/web-api/indigofair/data/ICollectionTile";
import { IProductBasedCollectionMetadata } from "@faire/web-api/indigofair/data/IProductBasedCollectionMetadata";
import { IRetailerProductBasedCollectionResponse } from "@faire/web-api/indigofair/data/IRetailerProductBasedCollectionResponse";
import { Grid } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

import { CollectionTile } from "@faire/retailer/features/MarketplaceItems/CollectionTile";

import { CollectionTileImpressionProvider } from "../CollectionTileImpressionProvider";

interface IProps {
  collection: IRetailerProductBasedCollectionResponse.IRetailerProductBasedCollection;
  otherCollections: IProductBasedCollectionMetadata[];
  columnCount: number;
  gridGap: number;
}

export const OtherProductBasedCollections: React.FC<IProps> = ({
  otherCollections,
  collection,
  columnCount,
  gridGap,
}) => {
  return (
    <>
      <Typography variant="pageHeaderSerifRegular">
        {collection?.brand_name ? (
          <StrictLocalMsg
            defaultMessage="More collections by {brandCompanyName}"
            description={{
              text: "title of section containing links to more product collections from the brand",
              img: "https://cdn.faire.com/fastly/ddc1d7e804bf356d2fe1cad7b0e2124d10e1c36a3cdd5aa8e2cf130c3335631d.png",
            }}
            values={{
              brandCompanyName: collection?.brand_name,
            }}
          />
        ) : (
          <StrictLocalMsg
            defaultMessage="More collections"
            description={{
              text: "title of section containing links to more product collections",
              img: "https://cdn.faire.com/fastly/8ec4201970ab26c65de8e5784ebfd3f6aee53b693a184200a1b179981fd1bde7.png",
            }}
          />
        )}
      </Typography>
      <Spacer height="2x" />
      <CollectionTileImpressionProvider
        contextToken={collection?.token}
        requestId={collection?.request_id}
        screenContext={ICollectionTile.Screen.PRODUCT_BASED_COLLECTION}
        containerContext={ICollectionTile.ScreenContainer.MORE_COLLECTIONS}
      >
        <Grid
          gap={gridGap}
          columns={Math.max(2, columnCount)}
          columnTemplate={(columns) => `repeat(${columns}, minmax(0, 232px));`}
        >
          {otherCollections.map((otherCollection, index) => (
            <CollectionTile
              key={`${otherCollection.product_based_collection_token}-${index}`}
              collection={otherCollection}
              onClick={() =>
                trackApparelCollectionsCollectionDetailsMoreCollectionsCollectionClick(
                  collection?.token ?? "",
                  otherCollection.product_based_collection_token!,
                  otherCollection.collection_promo
                    ?.brand_promo_collection_token ?? ""
                )
              }
            />
          ))}
        </Grid>
      </CollectionTileImpressionProvider>
    </>
  );
};
